import { t } from 'i18next';
import * as yup from 'yup';

import { QuotePartNoteType } from 'quotes/enums';

export const quotePartRemoveNotesSchema = (types: QuotePartNoteType[]) =>
  yup.object().shape({
    types: yup
      .object()
      .shape(
        types.reduce(
          (acc, type) => ({
            ...acc,
            [type]: yup.boolean().nullable(),
          }),
          {}
        )
      )
      .test('atLeastOneSelected', t('errorNoteTypeRequired'), (value) =>
        Object.values(value || {}).some(Boolean)
      ),
  });
